export const API_ENDPOINTS = {
  BOOTSTRAP: `${process.env.REACT_APP_API_PREFIX}bootstrap/`,
  SUMMARY_COUNTS: `${process.env.REACT_APP_API_PREFIX}summary-counts/`,
  ALL_DISTRICT_COUNTS: `${process.env.REACT_APP_API_PREFIX}all-district-counts/`,
  USERS: `${process.env.REACT_APP_API_PREFIX}users/`,
  USER_LIST: `${process.env.REACT_APP_API_PREFIX}user-list/`,
  USER_MASTER_LIST: `${process.env.REACT_APP_API_PREFIX}get-master-list/`,
  TEST_USER_MASTER_LIST: `${process.env.REACT_APP_API_PREFIX}test/get-master-list/`,
  UPDATE_MASTER_LIST: `${process.env.REACT_APP_API_PREFIX}update-master-list/`,
  EXPORT_MASTER_LIST: `${process.env.REACT_APP_API_PREFIX}export-master-list/`,
  TEST_EXPORT_MASTER_LIST: `${process.env.REACT_APP_API_PREFIX}test/export-master-list/`,
  BULK_DATA: `${process.env.REACT_APP_API_PREFIX}bulk-data/`,
  IMPORT_MASTER_LIST: `${process.env.REACT_APP_API_PREFIX}import-master-list/`,
  ASSOCIATES: `${process.env.REACT_APP_API_PREFIX}associates/`,
  FAMILY_HEAD: `${process.env.REACT_APP_API_PREFIX}family-heads/`,
  FAMILY_DETAILS: `${process.env.REACT_APP_API_PREFIX}family-details/`,
  LOGIN: `${process.env.REACT_APP_API_PREFIX}login/`,
  ADMIN_LOGIN: `${process.env.REACT_APP_API_PREFIX}admin/login/`,
  CREATE_VILLAGE: `${process.env.REACT_APP_API_PREFIX}create-village/`,
  VILLAGE_LIST: `${process.env.REACT_APP_API_PREFIX}village-list/`,
  STAFF_DATA: `${process.env.REACT_APP_API_PREFIX}staff-data/`,
  SCREENING_REPORT: `${process.env.REACT_APP_API_PREFIX}get-screening-report/`,
  FAMILY_MEMBER_LIST: `${process.env.REACT_APP_API_PREFIX}get-family-member-list/`,
  COUNT_SUMMARY: `${process.env.REACT_APP_API_PREFIX}get-summary-count/`,
  NEW_COUNT_SUMMARY: `${process.env.REACT_APP_API_PREFIX}new/get-summary-count/`,
  COUNT_TEST_SUMMARY: `${process.env.REACT_APP_API_PREFIX}test/get-summary-count/`,
  ALL_ASSESSMENTS: `${process.env.REACT_APP_API_PREFIX}all-assessments/`,
  GET_DASHBOARD: `${process.env.REACT_APP_API_PREFIX}get-dashboard/`,
  GET_TEST_DASHBOARD: `${process.env.REACT_APP_API_PREFIX}test/get-dashboard/`,
  GET_DASHBOARD_BY_DISTRICT: `${process.env.REACT_APP_API_PREFIX}get-dashboard-by-district/`,
  GET_TEST_DASHBOARD_BY_DISTRICT: `${process.env.REACT_APP_API_PREFIX}test/get-dashboard-by-district/`,
  GET_DM_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/dmCasesCount/`,
  GET_HTN_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/htnCasesCount/`,
  GET_ORAL_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/oralCasesCount/`,
  GET_BREAST_CANCER_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/breastCancerCasesCount/`,
  GET_CERVICAL_CANCER_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/cervicalCancerCount/`,
  GET_CVD_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/cvdCount/`,
  GET_COPD_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/copd/`,
  GET_CKD_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/ckd/`,
  GET_PS_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/psCount/`,
  GET_BMI_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/bmiCount/`,
  GET_MH_CASE_COUNT: `${process.env.REACT_APP_API_PREFIX}diseasae/mhCount/`,
  SCREENING_SUMMARY: `${process.env.REACT_APP_API_PREFIX}screening-summary/`,
  AREA_WISE_DATA: `${process.env.REACT_APP_API_PREFIX}area-wise-data/`,
  // Add more API endpoints as needed
};
